import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/site";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-44 lg:pb-32 overflow-hidden"
    >
      <div className="grain" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <span className="eyebrow" data-testid="hero-eyebrow">Dott.ssa Chiara Maiolo</span>
              <h1
                data-testid="hero-title"
                className="font-serif-elegant mt-6 text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#3D3B3A] leading-[1.05]"
              >
                Ascolto,<br />
                <span className="italic text-[#6B8568]">Consapevolezza</span>,<br />
                Equilibrio.
              </h1>
              <p
                data-testid="hero-subtitle"
                className="mt-8 text-base sm:text-lg text-[#73706E] max-w-xl leading-relaxed"
              >
                Psicologa clinica, sessuologa clinica ed esperta in
                comunicazione ipnotica. Uno spazio di supporto discreto e accogliente
                a Chivasso, libero dal giudizio, per affrontare insieme le
                difficoltà del quotidiano.
              </p>
              <div className="mt-10 flex flex-wrap items-center gap-4">
                <Link
                  to="/prenota"
                  data-testid="hero-cta-prenota"
                  className="group inline-flex items-center gap-2 bg-[#9DB39A] text-white hover:bg-[#7E9C7B] rounded-full px-8 py-4 text-sm tracking-wide transition-all duration-300"
                >
                  Prenota una seduta
                  <ArrowRight size={16} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform" />
                </Link>
                <Link
                  to="/servizi"
                  data-testid="hero-cta-servizi"
                  className="inline-flex items-center gap-2 text-sm text-[#3D3B3A] hover:text-[#7E9C7B] border-b border-[#3D3B3A] hover:border-[#7E9C7B] pb-1 transition-colors"
                >
                  Scopri i servizi
                </Link>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
              className="relative flex items-center justify-center py-8 lg:py-12"
            >
              <div className="absolute -top-4 -left-4 w-40 h-40 lg:w-56 lg:h-56 rounded-full bg-[#DAE3D2] -z-10 hidden lg:block" />
              <div className="absolute -bottom-6 -right-2 w-32 h-32 lg:w-44 lg:h-44 rounded-full bg-[#E9EFE4] -z-10 hidden lg:block" />
              <img
                src={ASSETS.logo}
                alt="Chiara Maiolo Psicologa"
                className="w-full max-w-[420px] h-auto object-contain"
                data-testid="hero-logo"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
